<template>
  <ca-modal
    ref="modal"
    size="small"
    title="Adicionar serviços">
    <template slot="body">
      <ca-form
        :is-valid.sync="isFormValid"
        :on-submit="onSubmit">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Descrição">
              <ca-input
                v-model="movement.description"
                required
                maxlength="45"></ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Data pagamento">
              <ca-date-input v-model="movement.paymentDate" required></ca-date-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col size="6">
            <ca-field label="Natureza">
              <ca-select v-model="movement.eventNature">
                <ca-option
                  v-for="(option, index) in eventNatureTypes"
                  :key="index"
                  :value="option">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Valor">
              <ca-input-currency
                v-model="movement.amount"
                maxlength="10"
                required>
              </ca-input-currency>
            </ca-field>
          </ca-col>
        </ca-row>
      </ca-form>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="close">
          Cancelar
        </ca-button>
      </ca-col>
      <ca-col offset="6" size="3">
        <ca-button
          :disabled="!isFormValid"
          theme="primary"
          @click="onSubmit">
          Confirmar
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import { initFormObject } from 'packages/common/utils';

export default {
  name: 'AddServiceModal',
  data() {
    return {
      movement: initFormObject(['nature']),
      isFormValid: null,
    };
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
    eventNatureTypes() {
      return this.misc.eventNatureTypes;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getEventNatureTypes');
    },
    onSubmit() {
      this.$emit('created', this.movement);
      this.close();
    },
    close() {
      this.$refs.modal.close();
    },
  },
};
</script>
